import React,{useContext, useEffect} from "react";
import { Checkbox, DefaultButton, Icon, PrimaryButton, Stack, TooltipHost } from "@fluentui/react";
import themeContext from "../../context/theme/ThemeContext";
import { USERTYPES } from "../../constants/Constants";
import studylistContext from "../../context/studylist/StudylistContext";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import { t } from "i18next";

const ListViewPagination = (props) => {

  const {theme, themeName, setThemeName, setTheme} = useContext(themeContext);


    return (
        <div
          className="pagination-list-view"
          style={{
            flexDirection: "row",
            justifyContent: "flex-start",
            marginBottom: "0px",
          }}
        >
          <div className="pagination-pageCount-study-list">
            <div
              className="left-right-icon-pagination"
              style={{
                cursor: !props.table.getCanPreviousPage() ? "not-allowed" : "pointer",
                opacity: !props.table.getCanPreviousPage() ? "0.5" : "1",
              }}
              onClick={() => props.table.previousPage()}
            >
              <Icon
                iconName="ChevronLeft"
                className={`pagination-pageCountElement-study-list ${
                  !props.table.getCanPreviousPage()
                    ? "pagination-disabled-study-list"
                    : ""
                }`}
                style={{color: themeName === "light"? "black":""}}
              ></Icon>
            </div>

            {props.arrayPageIndex.map((page, index) => {
              return (
                <DefaultButton
                  key={index}
                  className={`pagination-button-study-list pagination-pageCountElement-study-list ${
                    props.table.getState().pagination.pageIndex + 1 === page
                      ? "pagination-selected-study-list"
                      : ""
                  }`}
                  style={{
                    border: "none",
                    height: "28px",
                    pointerEvents: page == "......" ? "none" : "unset",
                    cursor: page == "......" ? "not-allowed" : "pointer",
                  }}
                  text={page == "......" ? "......" : page.toString()}
                  onClick={() => {props.table.setPageIndex(page-1)}}
                />
              );
            })}
            {props.arrayPageIndex.length==0 && 
                <DefaultButton
                  className={`pagination-button-study-list pagination-pageCountElement-study-list ${
                     "pagination-selected-study-list"
                  }`}
                  style={{
                    border: "none",
                    height: "28px",
                    pointerEvents: "none",
                    cursor: "pointer",
                  }}
                  text={"1"}
                  //onClick={() => table.setPageIndex(page-1)}
                />
                }
            {/* <div>
              <p
                className={`pagination-pageCountElement ${
                  !table.getCanNextPage() ? "pagination-disabled" : ""
                }`}
                onClick={() => table.setPageIndex(table.getPageCount() - 1)}
              >
                &nbsp;&nbsp; {t("statements.last")}
              </p>
            </div> */}
            <div
              className="left-right-icon-pagination"
              style={{
                cursor: !props.table.getCanNextPage() ? "not-allowed" : "pointer",
                opacity: !props.table.getCanNextPage() ? "0.5" : "1",
              }}
              onClick={() => props.table.nextPage()}
            >
              <Icon
                iconName="ChevronRight"
                className={`pagination-pageCountElement-study-list ${
                  !props.table.getCanNextPage()
                    ? "pagination-disabled-study-list"
                    : ""
                }`}
                style={{color: themeName === "light"? "black":""}}

              ></Icon>
            </div>
          </div>
          {/* <PrimaryButton 
            text={!props.showCount?"Hide Pagination":"Show Pagination"}
            onClick={()=>{props.setShowCount((prev)=>!prev)}}
        /> */}

        </div>
      
    )
}

export default ListViewPagination;